query GetFunds(
  $page: Int
  $limit: Int
  $stringFilters: [StringFilterInput!]
  $numericFilters: [NumericFilterInput!]
  $dateFilters: [DateFilterInput!]
  $legalEntityFilters: [ID!]
  $recordTypeFilters: [ID!]
  $sortBy: String
) {
  funds(
    page: $page
    limit: $limit
    stringFilters: $stringFilters
    numericFilters: $numericFilters
    dateFilters: $dateFilters
    legalEntityFilters: $legalEntityFilters
    recordTypeFilters: $recordTypeFilters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      openDate
      closedDate
      fundStatus
      preferredName
      fundGroup {
        id
        name
      }
      fundRecordType {
        id
        name
      }
      legalEntity {
        id
        name
      }
      dafPlan
      fundAccounts {
        id
        currency
        sageCode
        totalClearedBalance {
          minorUnit
          currency
        }
        totalClearedIncoming {
          minorUnit
          currency
        }
        totalClearedOutgoing {
          minorUnit
          currency
        }
        totalWorkingBalance {
          minorUnit
          currency
        }
        totalWorkingIncoming {
          minorUnit
          currency
        }
        totalWorkingOutgoing {
          minorUnit
          currency
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
